<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <Loading v-if="loading" :text="$t('finish-loading')"></Loading>
      <CalculatorHeading></CalculatorHeading>
      <h3 v-if="error">{{ error }}</h3>
      <div v-if="calcData" class="wrapper">
        <div class="packages">
          <div
            v-for="(p, i) in calcData"
            :key="i"
            class="package-div shadow-small grow"
          >
            <div class="package-subtitle">PACKAGE</div>
            <h3 style="margin-bottom: 6px">{{ $i18n.locale === "en" ? p.nameEn : p.nameDe }}</h3>
            <div class="cost-summary-text">{{ $i18n.locale === "en" ? p.summaryEn : p.summaryDe }}</div>
            <div class="package-cost"> {{ parseInt(p.cost).toLocaleString() }} €
              <span style="font-size: 12px">+ VAT</span>
            </div>
          </div>
        </div>

        <div class="cost">
          <div class="report-title">
            <!-- Last character is an emoji... can't be seen by Webstorm!-->
            {{ $t("summary.report-title") }}
            <span class="hand-right">👇</span>
          </div>

          <!--          <h3 class="cost-label">{{ $t("estimated-cost") }}</h3>-->
          <!--          <h4 style="padding-top: 15px">-->
          <!--            {{ $t("summary.report-body") }}-->
          <!--          </h4>-->

          <div style="padding-top: 30px">{{ $t("summary.report-includes") }}</div>
          <div
            style="padding-top: 15px"
            v-for="(benefit, i) in benefits"
            :key="i"
          >
            <font-awesome-icon
              class="checkbox-icon"
              :icon="['fas', 'check-circle']"
              @click="onSelect(true)"
            />
            {{ benefit }}
          </div>

          <div class="report-form">
            <input
              type="email"
              name="email"
              class="email-input"
              v-model="email"
              :placeholder="$t('summary.your-email')"
            />
            <one-button
              type="primary"
              class="email-submit-btn"
              @click="sendReportEmail()"
            >
              {{ $t("summary.get-report-btn") }}
            </one-button>
            <div class="email-error">{{ emailError }}</div>
            <div class="email-success">{{ emailSuccess }}</div>
          </div>
        </div>
      </div>

<!--      <div class="mail-img-div">-->
<!--        <img class="mail-img" src="@/assets/mailbox.svg" alt="Logo" />-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Loading from "../components/blocks/Loading";
import CalculatorHeading from "../components/CalculatorHeading";
import { BACKEND_URL } from "@/utils/config";
import { localizeUrl } from "@/utils/localizeUrl";
const axios = require("axios").default;

export default {
  name: "Finish",
  components: { CalculatorHeading, Loading },
  data() {
    return {
      dataId: null,
      loading: true,
      error: null,
      calcData: null,
      email: "",
      emailError: null,
      emailSuccess: null,
      benefits: [
        this.$t("summary.benefit-1"),
        this.$t("summary.benefit-2"),
        this.$t("summary.benefit-3"),
        this.$t("summary.benefit-4"),
        this.$t("summary.benefit-5"),
        this.$t("summary.benefit-6")
      ]
    };
  },
  mounted() {
    this.dataId = this.$route.query.id;
    if (!this.dataId) {
      this.loading = false;
      this.error = this.$t("summary.no-summary-found");
      setTimeout(
        () => this.$router.push(localizeUrl(`/`, this.$i18n.locale)),
        4000
      );
      return;
    }
    this.getData(this.dataId);
  },
  methods: {
    async getData(id) {
      try {
        const resp = await axios.get(BACKEND_URL + `/calculator-data?id=${id}`);
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        this.calcData = resp.data;
      } catch (error) {
        this.error = this.$t("summary.something-went-wrong");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async sendReportEmail() {
      this.emailError = null;
      this.emailSuccess = null;
      if (!this.validateEmail(this.email)) {
        this.emailError = this.$t("summary.email-not-valid");
        return;
      }
      try {
        this.emailSuccess = this.$t("summary.email-sending");
        const resp = await axios.post(BACKEND_URL + `/send-report`, {
          dataId: this.dataId,
          email: this.email,
          lang: this.$i18n.locale
        });
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        this.emailSuccess = this.$t("summary.email-success");

        await this.$router.push(localizeUrl("thank-you", this.$i18n.locale));
      } catch (error) {
        this.emailSuccess = null;
        this.emailError = this.$t("summary.email-fail");
        console.error(error);
      }
    },
    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 100px;
}
.cost {
  flex-grow: 1;
  flex-basis: 0;
  text-align: left;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  max-width: 600px;
}
.package-cost {
  font-family: "DejaVu Sans";
  padding-top: 6px;
  font-size: 18px;
  color: $color-primary;
  /*font-weight: bold;*/
}

.checkbox-icon {
  color: $color-primary;
  margin-right: 10px;
  margin-left: 15px;
}
.cost-number {
  font-size: 64px;
  font-weight: bold;
}
.cost-label {
  font-weight: 800;
  margin-bottom: 0px;
}
.report-title {
  font-size: 36px;
  font-weight: bold;
  font-family: $font-secondary;
}
.email-input {
  font-family: $font-primary;
  margin: 0 0 10px 0;
  border-radius: 25px;
  border: 1px solid #999;
  padding: 9px;
  width: 200px;
}
.email-submit-btn {
  margin: 0 10px 0 10px;
}
.report-form {
  margin-top: 30px;
  margin-bottom: 60px;
}
.work-with-us-img {
  max-width: 300px;
  margin-top: 40px;
}
.work-with-us-btn {
  margin-top: 30px;
}

.hand-right {
  display: inline-block;
}

.mail-img-div {
  display: flex;
  justify-content: center;
  padding: 40px;
  padding-top: 20px;
}

.mail-img {
  max-width: 700px;
}

@media only screen and (max-width: 960px) {
  .hand-right {
    display: none;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
  }
  .cost {
    text-align: left;
    order: 1;
  }
  .packages {
    order: 2;
  }
  .work-with-us {
    img {
      width: 100%;
    }
    margin: 0 20px 40px 20px;
    > h4 {
      padding: 0 20px 0 20px;
    }
  }

  .mail-img-div {
    margin-top: 30px;
    margin-bottom: 100px;
  }
  .mail-img {
    max-width: 90%;
  }

  .report-title {
    margin-bottom: 0px;
  }
  .report-form {
    margin-bottom: 20px;
  }
}

.email-error {
  padding-top: 10px;
  color: $color-error;
}
.email-success {
  color: $color-success;
}

@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.03);
  }
  60% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
.pulse {
  animation-name: pulse_animation;
  animation-duration: 2000ms;
  transform-origin: 50% 50%;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.packages {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  text-align: left;
  max-width: 500px;
}
.cost-summary-text {

}
.package-div {
  /*background-color: transparentize(#2c8c96, 0.85);*/
  padding: 24px;
  min-width: 300px;
  margin-bottom: 20px;
  border-radius: 10px;
  h3 {
    margin-top: 0;
  }
  .cost {
    font-size: 20px;
  }
}
@media only screen and (max-width: 960px) {
  .packages {
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }
  h3 {
    margin-top: 0;
  }
  .package-div {
    min-width: auto;
  }
}

.package-subtitle {
  font-size: 12px;
  font-weight: 900;
  color: $color-primary;
  margin-bottom: 6px;
}
</style>
